<template>
  <modal
    ref="modal"
    contentClasses="px-5 py-4 bg-body assign-agent-modal"
    size="xl"
    bodyClasses="py-0"
  >
    <template v-slot>
      <div class="d-flex">
        <p class="page-title font-weight-semibold my-auto">
          Gestisci condivisioni contatto
        </p>
        <icon
          name="Close"
          class="ml-auto my-auto clickable"
          @click.native="onDone"
          size="sm"
        ></icon>
      </div>

      <label class="font-weight-extrasmall">Cerca per nome</label>
      <div class="d-flex flex-column flex-md-row">
        <div class="px-0 my-md-auto">
          <div class="card">
            <div class="card-body px-3 py-2">
              <search-bar class="h-100" @search="onSearch" />
            </div>
          </div>
        </div>
        <!-- <button
          class="btn btn-primary mr-sm-auto ml-md-auto mr-md-0 my-md-auto mt-3 mt-md-0"
          @click="onDone"
        >Conferma</button> -->
      </div>
      <div class="bg-white mt-5 pt-2">
        <p class="px-3 text-muted">
          <small>Agenti con cui hai condiviso il contatto</small>
        </p>
        <div class="list-container d-flex">
          <i
            class="fas fa-circle-notch fa-spin text-primary m-auto fa-3x"
            v-if="getAgentsRequest.loading"
          ></i>
          <div class="w-100" v-if="!getAgentsRequest.loading && agents.length">
            <place-sharing-item
              :user="agent"
              v-for="agent in agents"
              :key="agent.id"
            />
          </div>
          <p class="m-auto" v-if="!getAgentsRequest.loading && !agents.length">
            Non è stato trovato nessun agente corrispondente a
            <b>"{{ search }}"</b>
          </p>
        </div>
      </div>

      <div class="d-flex mt-3" v-if="getAgentsRequest.meta">
        <paginator
          :meta="getAgentsRequest.meta"
          :range="5"
          :loading="getAgentsRequest.loading"
          @change="onPageChange"
          class="mx-auto"
        >
          <template v-slot:left-arrow>
            <i class="fa fa-arrow-left"></i>
          </template>
          <template v-slot:right-arrow>
            <i class="fa fa-arrow-right"></i>
          </template>
        </paginator>
      </div>
    </template>
  </modal>
</template>

<script lang="ts">
import { Component, Vue, Prop, Mixins } from "vue-property-decorator";
import { User } from "models";
import UsersMixin from "mixins/http/UsersMixin";
import { RegisterHttp } from "utils/Decorators";
import { RequestData } from "store/types";
import Modal from "components/Modal.vue";
import ModelSelect from "components/ModelSelect.vue";
import SearchBar from "components/SearchBar.vue";
import { Getter, Action, namespace } from "vuex-class";
import Paginator from "@monade/vue-components/src/components/Paginator.vue";
import { showToast } from "utils/Toast";
import PlaceSharingItem from "components/PlaceSharing/Item.vue";
import Icon from "components/Icon.vue";

const http = namespace("http");

@Component({
  components: {
    Modal,
    ModelSelect,
    SearchBar,
    Paginator,
    PlaceSharingItem,
    Icon,
  },
})
export default class ShareToAgent extends Mixins(UsersMixin) {
  static readonly getAgentsTag = "get_agents";
  private selectedAgent?: User = null;
  private agents?: Array<User> = Array();
  private search: string = "";
  private page = 1;

  @Getter currentUser;

  @RegisterHttp(ShareToAgent.getAgentsTag) getAgentsRequest: RequestData;

  show() {
    this.loadAgents();
    const modal = this.$refs.modal as any;
    modal.show();
  }

  onPageChange(page) {
    this.page = page;
    this.loadAgents();
  }

  onSearch(search) {
    this.search = search;
    this.page = 1;
    this.loadAgents({ term: search });
  }

  isSelected(agent) {
    return this.selectedAgent && agent.id === this.selectedAgent.id;
  }

  hide() {
    const modal = this.$refs.modal as any;
    modal.hide();
  }

  get params() {
    let data: any = {
      page: this.page,
      filter: {
        role: ["agent"],
        not: this.currentUser.id,
      },
    };

    return data;
  }

  loadAgents(searchParams: any = {}) {
    let params = this.params;

    if (searchParams) {
      params.filter.term = searchParams.term;
    }

    this.getUsers(params, ShareToAgent.getAgentsTag).then((resp) => {
      this.agents = resp;
    });
  }

  onDone() {
    this.hide();
  }

  onCancel() {
    this.hide();
    this.$emit("canceled");
  }
}
</script>

<style lang="scss" scoped>
.assign-agent-modal {
  .share-button {
    width: 130px;
  }
  .list-container {
    min-height: 400px !important;
    overflow-y: auto;
    tr {
      cursor: pointer;
    }
  }
}
</style>
